"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DurabilityCompliance() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = ["UL 969 Certified Materials", "Industrial Grade Durability", "Precision Laser Etching", "COMPLIANCE TO NFPA 70E"];
  return <section data-section-id="2520" id="durability-compliance" className="bg-background text-foreground relative w-full min-h-screen overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-screen">
        {}
        <div ref={leftRef} className={`relative w-full lg:w-[55%] flex items-center px-6 sm:px-10 lg:px-16 xl:px-20 py-16 lg:py-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute top-6 left-6 flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-muted-foreground uppercase">
            <span className="inline-block w-3 h-px bg-primary" />
            <span>FILE 02 / COMPLIANCE</span>
          </div>
          <div className="absolute bottom-6 left-6 font-mono text-[10px] tracking-[0.2em] text-muted-foreground uppercase">
            §02 — DURABILITY & COMPLIANCE
          </div>

          <div className="relative w-full max-w-2xl">
            {}
            <div className="font-mono text-xs sm:text-sm tracking-[0.25em] text-primary uppercase mb-8 lg:mb-10">
              § STANDARDS / DURABILITY
            </div>

            {}
            <h1 className="font-default font-bold text-foreground uppercase tracking-tight mb-8 lg:mb-10" style={{
            fontSize: "clamp(3.5rem, 8vw, 7rem)",
            lineHeight: "0.95",
            letterSpacing: "-0.03em"
          }}>
              Built to endure.
            </h1>

            {}
            <p className="text-[17px] leading-[1.6] text-muted-foreground max-w-[320px] mb-10 lg:mb-12">
              Our industrial labeling solutions are engineered for the harshest environments. From chemical resistance to extreme temperature tolerance, we ensure your facility remains compliant and your assets clearly identified.
            </p>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 mb-12 lg:mb-14 max-w-xl">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3 font-mono text-xs sm:text-[13px] tracking-[0.1em] text-foreground uppercase">
                  <span className="inline-block h-px w-3 bg-primary shrink-0" />
                  <span>{feature}</span>
                </div>)}
            </div>

            {}
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono tracking-[0.2em] uppercase text-xs h-12 px-7 rounded-md shadow-md group">
              <Link to="/ContactPage">
                Request Compliance
                <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative w-full lg:w-[45%] min-h-[60vh] lg:min-h-screen transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          {}
          <div className="absolute top-0 left-0 right-0 z-20 flex items-center justify-end gap-3 px-6 sm:px-8 pt-5">
            <span className="inline-block h-2 w-px bg-primary" />
            <span className="inline-block h-3 w-px bg-primary" />
            <span className="inline-block h-2 w-px bg-primary" />
          </div>

          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_compliance_labeling.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_compliance_labeling.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_compliance_labeling.png-wvc-sizes" alt="Industrial laser engraved labels mounted on heavy machinery in a manufacturing facility" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{
          filter: "saturate(0.7) hue-rotate(-5deg) brightness(0.85)"
        }} />

          {}
          <div className="absolute inset-0 pointer-events-none mix-blend-multiply" style={{
          background: "linear-gradient(180deg, hsla(210, 30%, 12%, 0.35) 0%, hsla(210, 30%, 8%, 0.55) 100%)"
        }} />

          {}
          <div className="hidden lg:flex absolute top-1/2 left-4 -translate-y-1/2 -rotate-90 origin-center font-mono text-[10px] tracking-[0.35em] text-foreground/60 uppercase whitespace-nowrap">
            UNIT 01 / COMPLIANCE PROTOCOL
          </div>

          {}
          <div className="absolute top-5 left-6 sm:left-8 font-mono text-[10px] tracking-[0.25em] text-foreground/80 uppercase">
            <span className="text-primary">●</span> CERT / VERIFIED
          </div>

          {}
          <div className="absolute bottom-6 right-6 sm:bottom-8 sm:right-8 z-10 text-right">
            <div className="font-mono text-[10px] tracking-[0.25em] text-foreground/60 uppercase mb-1">
              SPECIFICATIONS
            </div>
            <div className="font-mono text-xs sm:text-sm tracking-[0.15em] text-foreground">
              ISO 9001:2015
            </div>
            <div className="font-mono text-xs sm:text-sm tracking-[0.15em] text-foreground">
              UL 969 COMPLIANT
            </div>
          </div>

          {}
          <div className="absolute inset-0 pointer-events-none border-l border-border lg:border-l hidden lg:block" />
        </div>
      </div>
    </section>;
}